import * as Sentry from '@sentry/browser';
import {BrowserTracing} from '@sentry/tracing';
import {Angular as AngularIntegration} from '@sentry/integrations';

Sentry.init({
  dsn: 'https://cda5f5edbaa843f39a26fe5cf5563d96@o145685.ingest.sentry.io/6312266',
  integrations: [
    new AngularIntegration(),
    new BrowserTracing({
      tracingOrigins: ['https://app.gmride.com.my/']
    })
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0
});
